import { Platform } from "react-native";
import Constants from 'expo-constants';

const config = {
  ...Constants.manifest.extra,
  // currencySymbol: "NGN", // or '₦'

  // platform-specific configurations
  // mixpanel: Platform.OS === 'web' ? 'f0f7fc41ecf3746a728bb67ea0dc4cf2' : '12f0254ba5c3a4af3a0d27771bc03ff2',
};
export default config